<ul class="breadcrumbs">
  <li *ngFor="let url of urls; let last = last; let first = first" [ngClass]="{'active': last}"> <!-- disable link of last item -->
    <mat-icon *ngIf="!first">keyboard_arrow_right</mat-icon>
    <a (click)="navigateTo(url)" role="button" *ngIf="!last && url == prefix">{{url}}</a>
    <a (click)="navigateTo(url)" role="button" *ngIf="!last && url != prefix">{{friendlyName(url)}}</a>
    <span *ngIf="last">{{friendlyName(url)}}</span>
    <span *ngIf="last && url == prefix">{{friendlyName('/')}}</span>
  </li>
</ul>
